module.exports = function (PlayheadLayer, PointsLayer, SegmentsLayer, WaveformShape, MouseDragHandler, WaveformAxis, Utils, Konva) {
    'use strict';
    function WaveformZoomView(waveformData, container, peaks) {
        var self = this;
        self._originalWaveformData = waveformData;
        self._container = container;
        self._peaks = peaks;
        self._enableAutoScroll = true;
        self._options = peaks.options;
        self._data = null;
        self._pixelLength = 0;
        var initialZoomLevel = self._options.zoomLevels[peaks.zoom.getZoom()];
        self._resampleData(initialZoomLevel);
        self._width = container.clientWidth;
        self._height = container.clientHeight || self._options.height;
        self._frameOffset = 0;
        self._stage = new Konva.Stage({
            container: container,
            width: self._width,
            height: self._height
        });
        self._waveformLayer = new Konva.FastLayer();
        self._axis = new WaveformAxis(self, self._waveformLayer, peaks.options);
        self._createWaveform();
        self._segmentsLayer = new SegmentsLayer(peaks, self, true);
        self._segmentsLayer.addToStage(self._stage);
        self._pointsLayer = new PointsLayer(peaks, self, true, true);
        self._pointsLayer.addToStage(self._stage);
        self._playheadLayer = new PlayheadLayer(peaks, self, self._options.showPlayheadTime, self._options.mediaElement.currentTime);
        self._playheadLayer.addToStage(self._stage);
        var time = self._peaks.player.getCurrentTime();
        self._syncPlayhead(time);
        self._mouseDragHandler = new MouseDragHandler(self._stage, {
            onMouseDown: function (mousePosX) {
                this.initialFrameOffset = self._frameOffset;
                this.mouseDownX = mousePosX;
            },
            onMouseMove: function (mousePosX) {
                var diff = this.mouseDownX - mousePosX;
                var newFrameOffset = Utils.clamp(this.initialFrameOffset + diff, 0, self._pixelLength - self._width);
                if (newFrameOffset !== this.initialFrameOffset) {
                    self._peaks.emit('user_scroll.zoomview', newFrameOffset);
                }
            },
            onMouseUp: function (mousePosX) {
                if (!self._mouseDragHandler.isDragging()) {
                    var mouseDownX = Math.floor(this.mouseDownX);
                    var pixelIndex = self._frameOffset + mouseDownX;
                    var time = self.pixelsToTime(pixelIndex);
                    self._updateWaveform(pixelIndex - mouseDownX);
                    self._playheadLayer.updatePlayheadTime(time);
                    self._peaks.player.seek(time);
                }
            }
        });
        self._peaks.on('player_time_update', function (time) {
            if (self._mouseDragHandler.isDragging()) {
                return;
            }
            self._syncPlayhead(time);
        });
        self._peaks.on('user_seek', function (time) {
            var frameIndex = self.timeToPixels(time);
            self._updateWaveform(frameIndex - Math.floor(self._width / 2));
            self._playheadLayer.updatePlayheadTime(time);
        });
        self._peaks.on('user_scroll.zoomview', function (pixelOffset) {
            self._updateWaveform(pixelOffset);
        });
        self._peaks.on('player_play', function (time) {
            self._playheadLayer.updatePlayheadTime(time);
        });
        self._peaks.on('player_pause', function (time) {
            self._playheadLayer.stop(time);
        });
        self._peaks.on('zoom.update', function (currentScale, previousScale) {
            self.setZoomLevel(currentScale, previousScale);
        });
        self._peaks.on('window_resize', function () {
            self._width = self._container.clientWidth;
            self._stage.setWidth(self._width);
            self._updateWaveform(self._frameOffset);
        });
        function nudgeFrame(direction, large) {
            var increment;
            if (large) {
                increment = direction * self._width;
            } else {
                increment = direction * self.timeToPixels(self._options.nudgeIncrement);
            }
            self._updateWaveform(self._frameOffset + increment);
        }
        self._peaks.on('keyboard.left', nudgeFrame.bind(self, -1, false));
        self._peaks.on('keyboard.right', nudgeFrame.bind(self, 1, false));
        self._peaks.on('keyboard.shift_left', nudgeFrame.bind(self, -1, true));
        self._peaks.on('keyboard.shift_right', nudgeFrame.bind(self, 1, true));
    }
    WaveformZoomView.prototype.setWaveformData = function (waveformData) {
        this._originalWaveformData = waveformData;
    };
    WaveformZoomView.prototype._syncPlayhead = function (time) {
        this._playheadLayer.updatePlayheadTime(time);
        if (this._enableAutoScroll) {
            var pixelIndex = this.timeToPixels(time);
            var endThreshold = this._frameOffset + this._width - 100;
            if (pixelIndex >= endThreshold || pixelIndex < this._frameOffset) {
                this._frameOffset = pixelIndex - 100;
                if (this._frameOffset < 0) {
                    this._frameOffset = 0;
                }
                this._updateWaveform(this._frameOffset);
            }
        }
    };
    WaveformZoomView.prototype.setZoomLevel = function (currentScale, previousScale) {
        var currentTime = this._peaks.player.getCurrentTime();
        var apexTime;
        var playheadOffsetPixels = this._playheadLayer.getPlayheadOffset();
        if (playheadOffsetPixels >= 0 && playheadOffsetPixels < this._width) {
            apexTime = currentTime;
        } else {
            playheadOffsetPixels = this._width / 2;
            apexTime = this.pixelsToTime(this._frameOffset + playheadOffsetPixels);
        }
        this._resampleData(currentScale);
        var apexPixel = this.timeToPixels(apexTime);
        this._frameOffset = apexPixel - playheadOffsetPixels;
        this._updateWaveform(this._frameOffset);
        this._playheadLayer.zoomLevelChanged();
        this._playheadLayer.updatePlayheadTime(currentTime);
    };
    WaveformZoomView.prototype._resampleData = function (scale) {
        this._scale = scale;
        this._data = this._originalWaveformData.resample({ scale: scale });
        this._pixelLength = this._data.length;
    };
    WaveformZoomView.prototype.timeToPixels = function (time) {
        return Math.floor(time * this._data.sample_rate / this._data.scale);
    };
    WaveformZoomView.prototype.pixelsToTime = function (pixels) {
        return pixels * this._data.scale / this._data.sample_rate;
    };
    WaveformZoomView.prototype.getFrameOffset = function () {
        return this._frameOffset;
    };
    WaveformZoomView.prototype.getWidth = function () {
        return this._width;
    };
    WaveformZoomView.prototype.getHeight = function () {
        return this._height;
    };
    WaveformZoomView.prototype.setAmplitudeScale = function (scale) {
        if (!Utils.isNumber(scale) || !Number.isFinite(scale)) {
            throw new Error('view.setAmplitudeScale(): Scale must be a valid number');
        }
        this._waveformShape.setAmplitudeScale(scale);
        this._waveformLayer.draw();
        this._segmentsLayer.setAmplitudeScale(scale);
    };
    WaveformZoomView.prototype.getWaveformData = function () {
        return this._data;
    };
    WaveformZoomView.prototype._createWaveform = function () {
        this._waveformShape = new WaveformShape({
            color: this._options.zoomWaveformColor,
            view: this
        });
        this._waveformLayer.add(this._waveformShape);
        this._stage.add(this._waveformLayer);
        this._peaks.emit('zoomview.displaying', 0, this.pixelsToTime(this._width));
    };
    WaveformZoomView.prototype._updateWaveform = function (frameOffset) {
        var upperLimit;
        if (this._pixelLength < this._width) {
            frameOffset = 0;
            upperLimit = this._width;
        } else {
            upperLimit = this._pixelLength - this._width;
        }
        frameOffset = Utils.clamp(frameOffset, 0, upperLimit);
        this._frameOffset = frameOffset;
        var playheadPixel = this._playheadLayer.getPlayheadPixel();
        this._playheadLayer.updatePlayheadTime(this.pixelsToTime(playheadPixel));
        this._waveformLayer.draw();
        var frameStartTime = this.pixelsToTime(this._frameOffset);
        var frameEndTime = this.pixelsToTime(this._frameOffset + this._width);
        this._pointsLayer.updatePoints(frameStartTime, frameEndTime);
        this._segmentsLayer.updateSegments(frameStartTime, frameEndTime);
        this._peaks.emit('zoomview.displaying', frameStartTime, frameEndTime);
    };
    WaveformZoomView.prototype.setWaveformColor = function (color) {
        this._waveformShape.setWaveformColor(color);
        this._waveformLayer.draw();
    };
    WaveformZoomView.prototype.showPlayheadTime = function (show) {
        this._playheadLayer.showPlayheadTime(show);
    };
    WaveformZoomView.prototype.enableAutoScroll = function (enable) {
        this._enableAutoScroll = enable;
    };
    WaveformZoomView.prototype.destroy = function () {
        if (this._stage) {
            this._stage.destroy();
            this._stage = null;
        }
    };
    return WaveformZoomView;
}(require('peaks/views/playhead-layer'), require('peaks/views/points-layer'), require('peaks/views/segments-layer'), require('peaks/views/waveform-shape'), require('peaks/views/helpers/mousedraghandler'), require('peaks/waveform/waveform.axis'), require('peaks/waveform/waveform.utils'), require('konva'));